import { render } from "./calcel-btn.vue?vue&type=template&id=63945c9c&scoped=true"
import script from "./calcel-btn.vue?vue&type=script&lang=js"
export * from "./calcel-btn.vue?vue&type=script&lang=js"

import "./calcel-btn.vue?vue&type=style&index=0&id=63945c9c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63945c9c"]])

export default __exports__